/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import {
  Modal,
  Table,
  Button,
  HelpBlock,
} from 'react-bootstrap';
import TablePager from 'loracoms/TablePager';
import ShowIf from 'loracoms/ShowIf';
import Checkbox from 'loracoms/Checkbox';
import SearchInput from 'loracoms/SearchInput';
import IntlMsg from 'lorautils/intl/IntlMsg';
import callAPI from '@/api/callAPI';
import styles from './styles.scss';

const propTypes = {
  intl: PropTypes.object.isRequired,
  onHide: PropTypes.func.isRequired,
  checked: PropTypes.array.isRequired,
  onSuccess: PropTypes.func.isRequired,
  showModal: PropTypes.bool.isRequired,
};

class SelectGatewayModal extends React.Component {

  static getQ(search) {
    if (search) {
      const s = search.replace(/[-:]/g, '');
      return `or,name:*${s}*,platform:*${s}*,id:*${s}*,city:*${s}*,area:*${s}*,version:*${s}*,band:*${s}*`;
    }
    return null;
  }

  constructor(props) {
    super(props);
    this.state = {
      list: [],
      checked: props.checked,
      showModal: props.showModal,
      mark: 0,
      more: false,
      reset: 0,
    };
    this.intlMsg = new IntlMsg(props.intl, '');
    this.mark = 0;
    this.q = '';
  }

  componentWillMount() {
    this.loadGateways();
  }

  componentWillReceiveProps(nextProps) {
    const { showModal, checked } = nextProps;
    if (showModal !== this.props.showModal) {
      this.setState({ showModal });
      if (showModal) {
        this.loadGateways();
      }
    }
    if (_.isEqual(checked, this.props.checked)) {
      this.setState({ checked });
    }
  }

  getStatus(gw) {
    const disconnected = (
      <span>
        <i className={`fa fa-circle-o ${styles.disconnected}`} />
        {' '}
        {this.intlMsg.globalMsg('selectgateway.disconnected')}
      </span>
    );
    const connected = (
      <span>
        <i className={`fa fa-circle ${styles.connected}`} />
        {' '}
        {this.intlMsg.globalMsg('selectgateway.connected')}
      </span>
    );

    if (_.isNil(gw.lastOn)) {
      return disconnected;
    }
    if (_.isNil(gw.lastOff)) {
      return connected;
    }
    const onts = new Date(gw.lastOn).valueOf();
    const offts = new Date(gw.lastOff).valueOf();
    if (onts > offts) {
      return connected;
    }
    return disconnected;
  }

  loadGateways() {
    this.setState({ status: 'loading' });
    callAPI({
      endpoint: '/lora/gateways',
      query: {
        mark: this.mark,
        sort: '-lastOn',
        q: this.q,
      },
    }).then((res) => {
      this.setState({
        list: res.list,
        more: res.more,
        mark: res.mark,
        status: 'success',
      });
    }).catch(() => {});
  }

  handleSearch(e) {
    const search = _.trimStart(e.target.value);
    this.search = search;
    this.mark = '';
    this.q = SelectGatewayModal.getQ(search);
    this.setState({ search });

    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout);
    }
    this.searchTimeout = setTimeout(() => {
      this.loadGateways();
    }, 500);
  }

  isChecked(d) {
    const { checked } = this.state;
    return _.some(checked, { id: d.id });
  }

  toggleCheck(d) {
    let { checked } = this.state;
    if (this.isChecked(d)) {
      checked = _.filter(checked, c => c.id !== d.id);
    } else {
      checked = _.concat(checked, [d]);
    }
    this.setState({ checked });
  }

  handlePrevPage(mark) {
    this.mark = mark;
    this.loadGateways();
  }

  handleNextPage(mark) {
    this.mark = mark;
    this.loadGateways();
  }

  handleAdd() {
    const { checked } = this.state;
    this.props.onSuccess(checked);
    this.setState({ reset: new Date(), checked: [], mark: 0 });
    this.mark = 0;
  }

  render() {
    const { showModal, list, mark, more, reset, status, search = '' } = this.state;
    const { onHide } = this.props;
    const rows = _.map(list, item => (
      <tr key={item.id}>
        <td className={styles.checkbox}>
          <Checkbox
            id={item.id}
            checked={this.isChecked(item)}
            onChange={() => this.toggleCheck(item)}
          />
        </td>
        <td>{item.name}</td>
        <td>{this.getStatus(item)}</td>
        <td>{item.lng === 'undefined' ? '' : (item.lng || '')}</td>
        <td>{item.lat === 'undefined' ? '' : (item.lat || '')}</td>
      </tr>
    ));
    return (
      <Modal
        show={showModal}
        onHide={() => {
          this.setState({ checked: [] });
          onHide();
        }}
        bsClass="aisz-modal-light"
      >
        <Modal.Header closeButton className="clearfix">
          <span>
            <SearchInput
              placeholder={this.intlMsg.globalMsg('selectgateway.search.placeholder')}
              value={search}
              onChange={e => this.handleSearch(e)}
            />
          </span>
        </Modal.Header>
        <Modal.Body>
          <Table
            className="aisz-table-light"
            bordered
            responsive
          >
            <thead>
              <tr>
                <th />
                <th>{this.intlMsg.globalMsg('selectgateway.name')}</th>
                <th>{this.intlMsg.globalMsg('selectgateway.status')}</th>
                <th>{this.intlMsg.globalMsg('selectgateway.lng')}</th>
                <th>{this.intlMsg.globalMsg('selectgateway.lat')}</th>
              </tr>
            </thead>
            <tbody>
              {rows}
            </tbody>
          </Table>
          <div className={styles.tips}>
            <HelpBlock className={`aisz-help-block ${styles.flex}`}>
              <i className="fa fa-info-circle" />&nbsp;
              {this.intlMsg.msg('selectgateway.tips')}
            </HelpBlock>
            <ShowIf if={list.length > 0}>
              <div>
                <TablePager
                  status={status}
                  mark={mark}
                  more={more}
                  reset={reset}
                  onPrev={m => this.handlePrevPage(m)}
                  onNext={m => this.handleNextPage(m)}
                />
              </div>
            </ShowIf>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            bsStyle="aisz-success"
            className="pull-right"
            onClick={() => this.handleAdd()}
          >
            {this.intlMsg.globalMsg('selectgateway.confirm')}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

SelectGatewayModal.propTypes = propTypes;

const mapDispatchToProps = {
};

export default connect(
  null,
  mapDispatchToProps,
)(injectIntl(SelectGatewayModal));




// WEBPACK FOOTER //
// ./src/components/SelectGatewayModal/index.jsx